import React from 'react';

import { ActionButtonVariants } from 'components/action-button';
import { LayoutContainer } from 'components/layout/styled';
import LoadingAnimation from 'components/loading-animation';
import LoadingContainer from 'components/loading-animation/loading-container';
import { useFeatureLoyaltyNotAvailableAtDeliveryModeQuery } from 'generated/sanity-graphql';
import { FEATURE_LOYALTY_UI_SINGLETON } from 'hooks/use-feature-loyalty-ui/use-feature-loyalty-ui';

import {
  ImageContainer,
  NotAvailableContainer,
  SectionTitle,
  StyledActionButtonLink,
} from './loyalty-not-available-at-delivery-mode.styled';

const LoyaltyNotAvailableAtDeliveryMode: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { data, loading } = useFeatureLoyaltyNotAvailableAtDeliveryModeQuery({
    variables: { id: FEATURE_LOYALTY_UI_SINGLETON },
  });

  if (loading) {
    return (
      <LayoutContainer>
        <LoadingContainer>
          <LoadingAnimation />
        </LoadingContainer>
      </LayoutContainer>
    );
  }
  const loyaltyNotAvailableData = data?.LoyaltyUI?.loyaltyNotAvailableAtDeliveryMode;
  const imageUrl = loyaltyNotAvailableData?.image?.locale?.app;
  const imageAlt = loyaltyNotAvailableData?.image?.locale?.imageDescription || '';
  const title = loyaltyNotAvailableData?.title?.locale;
  const firstRedirectPath = loyaltyNotAvailableData?.firstRedirectPath?.locale || '';
  const firstButtonText = loyaltyNotAvailableData?.firstButtonText?.locale || '';

  return (
    <LayoutContainer>
      <NotAvailableContainer>
        <ImageContainer alt={imageAlt} image={imageUrl} />
        <SectionTitle variant="headerOne">{title}</SectionTitle>
        <StyledActionButtonLink variant={ActionButtonVariants.OUTLINE} to={firstRedirectPath}>
          {firstButtonText}
        </StyledActionButtonLink>
      </NotAvailableContainer>
    </LayoutContainer>
  );
};

export default LoyaltyNotAvailableAtDeliveryMode;
